import OrdersMonitor from '../src/components/sections/OrdersMonitor';

export default OrdersMonitor;
